import { render, staticRenderFns } from "./RightCase.vue?vue&type=template&id=06e80f30&scoped=true&"
import script from "./RightCase.vue?vue&type=script&lang=js&"
export * from "./RightCase.vue?vue&type=script&lang=js&"
import style0 from "./RightCase.vue?vue&type=style&index=0&id=06e80f30&prod&lang=scss&"
import style1 from "./RightCase.vue?vue&type=style&index=1&id=06e80f30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e80f30",
  null
  
)

export default component.exports